// 导出可复用的地图配置，不携带服务器身份、状态、修订号或运行数据。
const fields = ['name','code','description','rows','cols','width','height','unitWidth','unitHeight','defaultZoom','coordinateSystem','centerX','centerY','minX','minY','maxX','maxY','drawingMode','populationTolerance','areaTolerance','populationBalanceEnabled','areaBalanceEnabled','topologyCheckEnabled','cells','layers','objects','gridSchemes','parts','partPoints','zones','view','sceneSettings','roads','bridges','waterBodies','landmarks','mapEditorSchema']
export function exportMapConfiguration (draft) {
  return JSON.parse(JSON.stringify(Object.fromEntries(fields.filter(key => draft[key] !== undefined).map(key => [key, draft[key]]))))
}

// 编辑旧原型时把原先固定绘制的河流、三座桥转为明确配置；不回写来源实体。
export function mapSceneConfiguration (source, newMap = false) {
  const legacyCity = !source.mapEditorSchema && (source.roads || []).length > 0
  const width = Number(source.width) || 960, height = Number(source.height) || 640
  const legacyRiver = legacyCity && !source.waterBodies
  const migrateBridges = legacyRiver && !(source.bridges || []).length
  return {
    sceneSettings: { style: newMap || legacyCity ? 'CITY' : 'SIMPLE', matchPrototype: false, riverbank: !newMap && !source.sceneSettings && legacyCity, showCompass: true, showScale: true, metersPerUnit: 400 / 120, scaleUnits: 120, ...source.sceneSettings },
    roads: migrateBridges ? (source.roads || []).map(road => ({...road, bridge: false})) : source.roads || [],
    bridges: migrateBridges ? [320,640,800].map((x,index) => ({id:'legacy-bridge-'+index,name:['和平路桥段','江城路桥段','东环路桥段'][index],x1:x*width/960,y1:586*height/640,x2:x*width/960,y2:638*height/640,w:Math.min(22*width/960,width,height),cls:'art'})) : source.bridges || [],
    waterBodies: legacyRiver ? [{id:'legacy-river',name:'南江',type:'RIVER',x:0,y:586*height/640,width,height:54*height/640}] : source.waterBodies || [],
    landmarks: source.landmarks || []
  }
}

// 套用完整配置而非合并子资源，避免旧点位/网格引用残留；当前地图身份由调用方保留。
export function mapTemplateConfiguration (source, current) {
  const value = exportMapConfiguration(source)
  // 与打开旧模板时相同的显示兼容规则，避免目标的旧schema/场景设置渗入来源配置。
  value.mapEditorSchema = 1
  Object.assign(value, mapSceneConfiguration(source))
  for (const key of ['cells','layers','objects','gridSchemes','parts','partPoints','zones','roads','bridges','waterBodies','landmarks']) value[key] = value[key] || []
  value.view = value.view || {}
  value.description = value.description || ''
  value.name = current.name
  value.code = current.code
  return value
}
